import {
  Box,
  Button,
  Modal,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import {
  APP_CONTENT_DATE_PARAM,
  APPLICATION_CONTENT,
  ApplicationContentKey,
  LABELS,
} from "./constants";
import { COMMON_LABELS } from "../default-constants";
import { CompanyInfoRow } from "./CompanyInfoRow";
import { padWithFullWidthSpace } from "../../utils/format";
import { CompanyInfoHeader } from "./CompanyInfoHeader";

interface IDiffCheckModal {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  diffOfficialCompany: Record<ApplicationContentKey, string>;
  diffApplicationCompany: Record<ApplicationContentKey, string>;
}

/**
 * 申請内容照会 差分項目確認モーダル
 */
export const DiffCheckModal = (props: IDiffCheckModal) => {
  const {
    isModalOpen,
    setIsModalOpen,
    diffOfficialCompany,
    diffApplicationCompany,
  } = props;

  /**
   * モーダルを閉じる.
   */
  const onClose = () => setIsModalOpen(false);

  return (
    <Modal
      onDismiss={onClose}
      visible={isModalOpen}
      size="max"
      header={LABELS.DIFF_ITEM_CONTENT}
      footer={
        <Box float="left">
          <Button formAction="none" variant="link" onClick={onClose}>
            {COMMON_LABELS.BTNS.CLOSE}
          </Button>
        </Box>
      }
    >
      <SpaceBetween direction="vertical" size="xxxs">
        <CompanyInfoHeader />
        {Object.keys(diffOfficialCompany).map((key, index) => {
          return (
            <CompanyInfoRow
              key={`${key}-${index}`}
              label={padWithFullWidthSpace(
                APPLICATION_CONTENT[key as ApplicationContentKey],
                11
              )}
              official={diffOfficialCompany[key as ApplicationContentKey]}
              application={diffApplicationCompany[key as ApplicationContentKey]}
              isDate={APP_CONTENT_DATE_PARAM.includes(key)}
            />
          );
        })}
      </SpaceBetween>
    </Modal>
  );
};
